import styled from 'styled-components';

export const TOCContainer = styled.div`
  width: 341px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  background: var(--white);
  border: 1px solid var(--grey-3);
  border-radius: 8px;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
`;

export const Header = styled.div`
  padding: 20px 20px 13px 20px;
  border-bottom: 1px solid var(--grey-4);
  .toc--heading {
    margin: 0px;
    font-weight: var(--font-weight-700);
  }
`;

export const Links = styled.div`
  max-height: calc(100vh - ${({ maxHeightBoundary }) => maxHeightBoundary + 180}px);
  min-height: 100px;
  border-radius: 8px;
  padding: 10px 0px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  background-color: var(--white);

  .toc--link-container {
    width: 100%;
    margin: 0 auto;

    .toc--link {
      display: table;
      height: 100%;
      width: 100%;
      margin: 0px;
      padding: 7px 15px 7px 20px;
      a {
        color: inherit;
      }
    }

    &.toc--link-active {
      border-left: 6px var(--titan-blue-3) solid;
      .toc--link {
        padding-left: 14px;
      }
    }
  }
`;
